import { inject, Injectable } from '@angular/core';
import { LogoStoreAdapter } from '@/app/_infrastructure/adapters/store/logo/logo.adapter';
import { LogoInterface } from '../../domain/interfaces/logo/logo.interface';
import { LogoConfig } from '@/app/_core/domain/models/logo/logo.model';

@Injectable({
  providedIn: 'root'
})
export class LogoUseCase implements LogoInterface {
  private readonly _logoStoreAdapter = inject(LogoStoreAdapter);

  public setLogo(logo: LogoConfig): void {
    this._logoStoreAdapter.setLogo(logo);
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////
  public selectLogoSig = this._logoStoreAdapter.selectLogoSig;
}
